import { createFileRoute } from '@tanstack/react-router';

import { DeletedAssessmentsContent } from '@/features/dashboard/components/deleted-assessments-content';

export const Route = createFileRoute('/_authenticated/deleted-assessments')({
  component: DeletedAssessmentsPage,
});

function DeletedAssessmentsPage() {
  return <DeletedAssessmentsContent />;
}
